export enum PreOrderLookupStatus {
  DOES_NOT_EXIST = 1,
  SUCCESS,
  SYSTEM_FAILURE,
  TIMEOUT,
}
